export default "__VITE_ASSET__DqG_OBpM__"